(function ($) {

  if($('.award-year-group').length) {

    $('.award-year-group').each(function() {
      let _this = $(this);
      let _yearSlide = _this.find('.year-group__list');
      let _itemsSlide  = _this.find('.year-group__items');
      let _yearNum = _this.find('.year-group__list-year').length;
      let slideToShow = 6;
      if(_yearNum < 6) {
        slideToShow = _yearNum;
      }
      let _yearSlideOption = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        focusOnSelect: true,
        asNavFor: _itemsSlide,
        mobileFirst: true,
        responsive: [{
          breakpoint: 620,
          settings: {
            slidesToShow: slideToShow,
          }
        }]
      };
      let _itemSlideOption = {
        infinite: false,
        slidesToShow: 1,
        dots: false,
        arrows: false,
        adaptiveHeight: true,
        fade: true,
        cssEase: 'linear',
      }

      $('.single-level-list-content-slide').on('afterChange', function(){
        _yearSlide.not('.slick-initialized').slick(_yearSlideOption);
        _itemsSlide.not('.slick-initialized').slick(_itemSlideOption);
      });

      $('.m__type-item__accordion-title').on('click', function () {
        _yearSlide.not('.slick-initialized').slick(_yearSlideOption);
        _itemsSlide.not('.slick-initialized').slick(_itemSlideOption);
      });

      _this.find('.show-more').on('click',function() {
        let _btn = $(this);
        _btn.parent('.year-group__items__peoples').addClass('showAll');
        _btn.hide();
        _this.find('.year-group__items .slick-list').height('auto');
      });
    });
  }

  $('.section--research-accordion-listing .child-item-wrapper').unbind().bind('click', function () {
    $('.single-level-list-content-slide').slick('slickGoTo', $(this).attr('data-slide'));
    $('.section--research-accordion-listing .child-item-wrapper').removeClass('active');
  });

  if ($('.single-level-list-content-slide').length) {

    function getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      let results = regex.exec(location.href);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, '    '));
    }

    let section = getUrlParameter('section');
    if (section) {
      $('.title-wrapper').removeClass('active');
      $('.title-wrapper').eq(section).addClass('active');
      $('.single-level-list-content-slide').slick('slickGoTo', parseInt(section));

      if($('.m__type-item__accordion-title').length) {
        $('.m__type-item').eq(section).find('.m__type-item__accordion-title').addClass('active');
        $('.m__type-item').eq(section).find('.m__type-item__accordion-content').stop(true).slideDown(444);
      }
    }



    $('.single-level-list-content-slide').not('.slick-initialized').slick({
      arrows: false,
      dots: false,
      swipe: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      cssEase: 'linear',
      adaptiveHeight: true
    });


  }

  // $(window).resize(function () {
  //   $('.single-level-list-content-slide').slick('resize');
  // });


})(jQuery);
